module.exports = __webpack_public_path__ + "static/constructive-cce251a53f8c9c915128855f3d21eb89.jpg";